var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.582,
    height: 29.882,
    viewBox: "0 0 31.582 29.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13273",
    "data-name": "Group 13273",
    transform: "translate(-9.32 -174.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45062",
    "data-name": "Path 45062",
    d: "M25.314,6.893c-.467.432-.936.863-1.4,1.3q-3.851,3.6-7.7,7.2-3.011,2.814-6.02,5.629a.5.5,0,0,1-.579.125q-4.056-1.4-8.119-2.783a2.12,2.12,0,0,1-1.179-.837,1.9,1.9,0,0,1,.754-2.752C2.128,14.2,3.2,13.655,4.262,13.1L21.621,3.979c2.371-1.245,4.74-2.5,7.116-3.732a1.9,1.9,0,0,1,2.648.8,2.275,2.275,0,0,1,.148,1.44q-1.064,6.986-2.121,13.972-.651,4.29-1.3,8.58a1.913,1.913,0,0,1-2.645,1.539L17.377,23.8l-4.026-1.383c-.4-.136-.4-.151-.143-.466L25.266,7.058c.033-.041.061-.085.092-.128l-.043-.037",
    transform: "translate(9.32 174.5)",
    fill: "#014fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45063",
    "data-name": "Path 45063",
    d: "M120.962,255.315c0-.755.007-1.51,0-2.264,0-.295.1-.354.37-.259,2.214.766,4.431,1.523,6.646,2.286.326.112.335.156.071.392-1.288,1.15-2.574,2.3-3.872,3.439a1.825,1.825,0,0,1-2.074.338,1.874,1.874,0,0,1-1.137-1.84c-.006-.7,0-1.4,0-2.093",
    transform: "translate(-100.535 -55.049)",
    fill: "#014fe0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/Submit-Icon.8257682b849e1b583d20464097a9ee0c.svg";
export { ForwardRef as ReactComponent };